// extracted by mini-css-extract-plugin
export default {"advSec":"AdvSec_advSec__Y0vUr","advContent":"AdvSec_advContent__l08DX"};